export default {
  setLoadingNegocioGest(state, b) {
    state.loadingNegocioGest = b;
  },
  setNegocioGest(state, negocio) {
    state.negocioGest = negocio;
  },
  setDirectorioGest(state, directorio) {
    state.directorioGest = directorio;
  },
  setNegocioObjGest(state, negocio) {
    state.negocioObjGest = negocio;
  },
  setDirectorioObjGest(state, directorio) {
    state.directorioObjGest = directorio;
  },
  setRestauranteGest(state, rest) {
    state.restauranteGest = rest;
  },
  setNegociosGestArray(state, negocios) {
    state.negociosGestArray = negocios;
  },
  setRestaurantesArray(state, rest) {
    state.restaurantesArray = rest;
  },
  setNegocioFiltrarRestaurante(state, negF) {
    state.negocioFiltrarRestaurante = negF;
  },
  setModoDesarrollo(state, modo) {
    state.modoDesarrollo = modo;
  },
  addTiempoReal(state, r) {
    state.arrayTiempoReal.push(r);
  },
  resetTiempoReal(state) {
    state.arrayTiempoReal = [];
  },
  setDashboardConfig(state, c) {
    state.dashboardConfig = c
  },
  setClientesFacturar(state, cs) {
    state.clientesFacturar = cs;
  },
  setPartner(state, p) {//p = {id,nombre}
    state.partner = p;
  },
  setPartnerNegocios(state, n) {
    state.partnerNegocios = n;
  },
  setPartnerNegociosObj(state, n) {
    state.partnerNegocios = n;
  },
  setStatusCuentas(state, a) {
    state.statusCuentas = a;
  }
}
